module.exports = __webpack_public_path__ + "img/sn.c47a2ba4.png";